import { render, staticRenderFns } from "./RBadge.vue?vue&type=template&id=6e07f122&scoped=true"
import script from "./RBadge.vue?vue&type=script&lang=js"
export * from "./RBadge.vue?vue&type=script&lang=js"
import style0 from "./RBadge.vue?vue&type=style&index=0&id=6e07f122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07f122",
  null
  
)

export default component.exports